import * as commonApi from "@ide/shared/api/common";
import { useMutation } from "@tanstack/react-query";
import { useParams, usePathname } from "next/navigation";

const useCollect = () => {
  const params = useParams();

  const { isPending, isSuccess, isError, mutate, variables, status } = useMutation({
    mutationFn: async (values) =>
      commonApi.collect({
        ...values,
        // ref: getCookie("ref"),
        url: window?.location?.href,
        lang: params?.lang,
        referrer: document.referrer,
      }),
  });

  return {
    isLoading: isPending,
    isSuccess,
    isError,
    status,
    collect: mutate,
  };
};

export default useCollect;
